"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var ShopContainer_1 = require("../components/ShopV2/ShopContainer");
var targetNode = document.querySelector('.shop-v2');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(ShopContainer_1.default, null), targetNode);
}
